// extracted by mini-css-extract-plugin
export default {"fieldSet":"FieldSet-fieldSet-CMapa","legend":"FieldSet-legend-M8__d","small":"FieldSet-small-SxwJl"};